import { who_throttle } from "./helpers";


export default class ScrollbarWidth{

    constructor(){

        this.resizing();

        const resizing = this.resizing ;

        window.addEventListener('resize', function(){
            const the_resizing = who_throttle( resizing, 250 );
        });
    }

    resizing(){
        const scrollbarWidth = window.innerWidth - document.body.clientWidth ;
        document.body.style.setProperty("--who--js--scrollbar--width", `${scrollbarWidth}px`) ;
    }

}